import { permissionsRol as contentRol } from 'app/policies/roles/contentsRol.access';
import { PATH_ACTIVITY_BATCH_CREATE, PATH_ACTIVITY_BATCH_REVIEW } from 'app/router/routesConfigActivityBatches';

// `path` es el patrón de la ruta (Routes.jsx pasa item.path), así que se compara contra la constante.
const GATED_PATHS = new Set([PATH_ACTIVITY_BATCH_CREATE, PATH_ACTIVITY_BATCH_REVIEW]);

// L1 (TAN-8123) el listado no aplica gating por rol: el acceso al banco ya está protegido por autenticación.
// TAN-8127 la creación (wizard) y TAN-8136 el panel de revisión requieren el flag
// showActivitiesBatchManagement y permiso de creación de contenidos.
export function activityBatches({ flags, path, user }) {
  if (GATED_PATHS.has(path)) {
    return !!flags?.showActivitiesBatchManagement && contentRol(user).create;
  }

  return true;
}
